export default "__VITE_ASSET__BwLA8gUc__"